// The activities' sign (Erik 2026-11-02): a lit light bulb — light honey glass, rays around it. Used on the teacher's
// Aktiviteter button and in the students' lesson bar for every activity that is running (the tooltip and the popup
// say which one). Line style of the site's icons (24×24, round caps, currentColor for the lines); the glass is
// filled with a light honey, and `lyser` adds a soft honey glow that breathes (still under prefers-reduced-motion).

import styles from "./aktivitet-lampa.module.css";

export default function AktivitetLampa({ className = "h-[18px] w-[18px]", lyser = false }: { className?: string; lyser?: boolean }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={`${className} ${lyser ? styles.lyser : ""}`}
    >
      <path d="M12 1.5v1.7M4.3 4.6l1.2 1.2M19.7 4.6l-1.2 1.2M2 11h1.7M20.3 11H22" />
      <path
        d="M9.1 17.2c0-1.8-.9-2.8-1.9-4a5.3 5.3 0 1 1 9.6 0c-1 1.2-1.9 2.2-1.9 4z"
        style={{ fill: "color-mix(in oklch, var(--color-figur-honung) 65%, var(--color-bg))" }}
      />
      <path d="M9.4 19.7h5.2M10.6 22h2.8" />
      <path d="M10.5 13.4l1.5-1.8 1.5 1.8" />
    </svg>
  );
}
